<template>
  <v-card class="mx-auto" min-width="90%" max-width="344" color="#1F7087" dark>
    <v-card-text class="white--text">
      <div class="headline mb-2">{{account.name}}. {{account.currency}}</div>
      Open: {{account.opening_balance | price(account.currency)}}
      <span v-if="account.notes">"{{account.notes}}"</span>
    </v-card-text>
    <v-card-actions>
      <v-btn text>Detail</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {
    account: Object
  }
}
</script>
